import {
  Accordion,
  Button,
  Flex,
  SimpleGrid,
  Text,
  Tooltip,
  useMantineTheme,
} from "@mantine/core";
import { InfoCircle, Setting3 } from "iconsax-react";
import { EPlanStatus } from "../../../../interfaces/MyPlans/IMyPlans";
import { useConfigContext } from "./ConfigProvider";
import { useTranslation } from "react-i18next";
import TitleDescription from "./TitleDescription";

export default function AccordionDanger() {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const { product, states, modals, handlers } = useConfigContext();

  return (
    <>
      <Accordion.Item value="Danger">
        <Accordion.Control p="0">
          <Flex
            id="lineOneCardProduct"
            justify="start"
            align={"center"}
            gap="8px"
          >
            <Setting3 size="24" color={theme.colors.basic[5]} />
            <Text
              fz={{ base: 18 }}
              lh={{ base: "155%" }}
              c={theme.colors.basic[5]}
            >
              {t(
                "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_danger.title"
              )}
            </Text>
          </Flex>
        </Accordion.Control>
        <Accordion.Panel
          sx={{
            ".mantine-Accordion-content": {
              padding: "0px !important",
              margin: "20px 0",
            },
          }}
        >
          <Flex
            gap={{ base: 30 }}
            w="100%"
            direction={"column"}
            justify={"space-between"}
            style={{
              border: "1px solid",
              borderColor: theme.colors.basic[2],
              borderRadius: "20px",
            }}
            p="20px"
          >
            <Flex direction={"column"} gap="20px">
              <TitleDescription
                title={t(
                  "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_danger.subtitle_1"
                )}
                description={t(
                  "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_danger.description_1"
                )}
                hasDivider="630px"
              />
              <SimpleGrid
                spacing="24px"
                w="100%"
                breakpoints={[
                  { minWidth: 700, cols: 2 },
                  { minWidth: 1200, cols: 3 },
                ]}
              >
                <Button
                  variant={"primaryOutline"}
                  maw="500px"
                  w={"100%"}
                  onClick={() => modals.setOpenActiveAlgorithm(true)}
                  disabled={
                    !states.isAlgorithmRunning || states.isEnabledToRunAlgorithm
                  }
                >
                  <Flex gap="4px">
                    {t(
                      "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_danger.button_algorithm_deactive"
                    )}
                    <InfoCircle size={24} />
                  </Flex>
                </Button>
              </SimpleGrid>
            </Flex>

            {states.hasCancelButton ? (
              <Flex direction={"column"} gap="20px">
                <TitleDescription
                  title={t(
                    "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_danger.subtitle_2"
                  )}
                  description={t(
                    "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_danger.description_2"
                  )}
                  hasDivider="630px"
                />
                <Button
                  variant="danger"
                  maw="500px"
                  w={"100%"}
                  type="button"
                  onClick={handlers.handleCancel}
                  disabled={
                    !!product.status &&
                    product.status === EPlanStatus.CancelRequested
                  }
                >
                  {t(
                    "meu_portfolio.minhas_compras.configuracao_do_serviço.accordion_danger.button_cancel"
                  )}
                </Button>
              </Flex>
            ) : null}
          </Flex>
        </Accordion.Panel>
      </Accordion.Item>
    </>
  );
}
